import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
export const orderResendMail = async (orderId: string) => {
  try {
    const url = `${ENDPOINTS.ORDER}/${orderId}/resend_email`
    const response = await api.put(url)
    return { success: true, data: response }
  } catch (error) {
    console.error(error)
    return { success: false }
  }
}
